import { useQuery } from '@tanstack/react-query'
import { apiSdk } from '../../api'

export const getPaymentMethodsQuery = (checkoutSession: string, publicApiKey: string, language?: string) => ({
  queryKey: ['payment-methods', checkoutSession, publicApiKey, language],
  queryFn: () => apiSdk.getPaymentMethods(checkoutSession, publicApiKey),
})

export const useGetPaymentMethods = (checkoutSession: string, publicApiKey: string, language?: string) =>
  useQuery(getPaymentMethodsQuery(checkoutSession, publicApiKey, language))
